import Breadcrumbs from "@/components/common/sections/Breadcrumbs";
import BreadcrumbsImage from "@/assets/images/breadcrumbs/ai-solutions1.webp";

export default function AISolutionsPage() {
	return (
		<>
			<Breadcrumbs
				title="Our solutions are Automated Workflows"
				breadcrumbText="AI solutions"
				backgroundImage={BreadcrumbsImage}
			/>
		</>
	);
}